// extracted by mini-css-extract-plugin
module.exports = {"product-related-component":"Related_product-related-component__2S0vk","product-action-title":"Related_product-action-title__FJ6s0","active":"Related_active__JHFgX"};